export const Typography = {
    fontFamily: 'Inter',
    weight: {
        light: 300,
        regular: 400,
        medium: 500,
        semibold: 600,
        bold: 700,
    },
    lineHeight: {
        // rem
        ui: 1,
        text: 1.5,
        display: 1.25
    },
    fontSize: {
        //desktop
        ui_xxs: '10px',
        ui_xs: '12px',
        ui_s: '14px',
        ui_m: '16px',
        ui_l: '18px',
        ui_xl: '20px',
        ui_xxl: '24px',

        text_xs_desktop: '12px',
        text_sm_desktop: '14px',
        text_md_desktop: '16px',
        text_lg_desktop: '20px',
        text_xl_desktop: '24px',
        text_xxl_desktop: '32px',
        
        display_xs_desktop: '40px',
        display_sm_desktop: '48px',
        display_md_desktop: '56px',
        display_lg_desktop: '64px',
        display_xl_desktop: '72px',
        display_xxl_desktop: '80px',

        //videowall
        text_xxs_videowall: '0',
        text_xs_videowall: '0',
        text_sm_videowall: '0',
        text_md_videowall: '0.469vw',//In Cascais (7680x2169) = 36.0px,
        text_lg_videowall: '0.547vw',//In Cascais (7680x2169) = 42.0px,
        text_xl_videowall: '0.625vw',//In Cascais (7680x2169) = 48.0px,
        text_xxl_videowall: '0.704vw', //In Cascais (7680x2169) = 54.0px,
        text_xxxl_videowall: '1.042vw', //In Cascais (7680x2169) = 80.0px,
    }, 
};
